module.exports = __webpack_public_path__ + "static/media/graphics_card.6d21013a.png";